import Image from 'next/image';
import { getFileUrl } from '@/app/(main)/gallery/utils/getFileUrl';
import type { SearchDetailsRolesType } from '@/app/(main)/search-details/consts/search-details';
import { getCustomerRoleBadge } from '@/app/(main)/search-details/utils/getCustomerRoleColor';
import { HighlightedText } from '@/app/components/HighlightedText';
import { getPath } from '@/consts/paths';
import type { GlobalSearchDirectoryItem } from '@/types/globalSearchApiTypes';
import { SearchItemTitle } from '../SearchItemTitle';
import { SearchItemWrapper } from '../SearchItemWrapper';

interface DirectoryItemProps {
  item: GlobalSearchDirectoryItem;
}

export const DirectoryItem = ({ item }: DirectoryItemProps) => {
  const fullName = `${item.first_name} ${item.last_name}`;
  const initials = [item.first_name, item.last_name].map((name) => name[0]).join('');

  return (
    <SearchItemWrapper href={getPath(item.redirect_url)}>
      <div className="flex items-center gap-2">
        <div className="flex self-start">
          {item.avatar ? (
            <Image
              src={getFileUrl(item.avatar) ?? ''}
              alt={fullName}
              width={32}
              height={32}
              className="rounded-[2px] object-cover self-start"
            />
          ) : (
            <div className="flex justify-center items-center w-8 h-8 rounded-full bg-grey-100 border-2 border-black/[.12]">
              <span className="font-inter text-[12px] font-semibold text-neutral-700 uppercase">{initials}</span>
            </div>
          )}
        </div>
        <div className="flex flex-col gap-1 max-md:min-w-0">
          <div className="flex items-center gap-[6px]">
            <SearchItemTitle>{fullName}</SearchItemTitle>
            {getCustomerRoleBadge(item.role as SearchDetailsRolesType)}
          </div>
          <div className="flex gap-1 max-md:flex-wrap">
            <p className="text-body-small text-black !leading-[140%]">
              {item.email && <span>{<HighlightedText>{item.email}</HighlightedText>}; </span>}
              {item.designation && (
                <span>
                  designation:{' '}
                  <span className="text-black">
                    <HighlightedText>{item.designation}</HighlightedText>
                  </span>
                  ;
                </span>
              )}
            </p>
            <p className="text-body-small text-grey-700 !leading-[140%]">
              {item.agency_llc_name && (
                <span>
                  agency:{' '}
                  <span className="text-black">
                    <HighlightedText>{item.agency_llc_name}</HighlightedText>
                  </span>
                  ;
                </span>
              )}
            </p>
            <p className="text-body-small text-black !leading-[140%]">
              {(item.user_city || item.user_state) && (
                <>
                  <HighlightedText>{item.user_city ? `${item.user_city}, ` : ''}</HighlightedText>
                  <HighlightedText>{item.user_state ? `${item.user_state}` : ''}</HighlightedText>;
                </>
              )}
            </p>
          </div>
        </div>
      </div>
    </SearchItemWrapper>
  );
};
